module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n        " + _vm._s(_vm.params.noticeTitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "440px",
      "margin": "30px auto 40px",
      "border": "1px solid #e6e6e6"
    }
  }, [_c('div', {
    staticClass: "noticeMenu"
  }, [_c('div', {
    staticClass: "oldAccount fl",
    class: {
      active: !_vm.isNewStudent
    },
    on: {
      "click": _vm.oldStuClick
    }
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v("\n            已有账号\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "newAccount fl",
    class: {
      active: _vm.isNewStudent
    },
    on: {
      "click": _vm.newStuClick
    }
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v("\n            新建账号\n          ")])]), _vm._v(" "), (!_vm.isNewStudent) ? _c('div', {
    staticClass: "searchStuBox"
  }, [_c('div', {
    staticClass: "noticeSearchStu"
  }, [_c('div', {
    staticClass: "searchBox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userId),
      expression: "userId"
    }],
    staticClass: "field",
    attrs: {
      "type": "text",
      "placeholder": "请输入学生的账号/手机号"
    },
    domProps: {
      "value": (_vm.userId)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userId = $event.target.value
      }, _vm.search]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "searchStudent"
  })])]), _vm._v(" "), (_vm.newStudentInf) ? _c('div', {
    staticClass: "searchResult"
  }, [_c('p', [_vm._v("可能添加的学生:")]), _vm._v(" "), _c('div', {
    staticClass: "studentInf"
  }, [(_vm.newStudentInf.avatar) ? _c('img', {
    staticClass: "studentImg",
    attrs: {
      "src": _vm.newStudentInf.avatar,
      "alt": _vm.newStudentInf.realName
    }
  }) : (!_vm.newStudentInf.avatar) ? _c('img', {
    staticClass: "studentImg",
    attrs: {
      "src": require("./../../assets/img/photo.png"),
      "alt": _vm.newStudentInf.realName
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "studentName"
  }, [_vm._v(_vm._s(_vm.newStudentInf.userName))]), _vm._v(" "), (false) ? _c('img', {
    staticClass: "sex",
    attrs: {
      "src": _vm.newStudentInf.src,
      "alt": "性别"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "studentAccount"
  }, [_vm._v(_vm._s(_vm.newStudentInf.userId))]), _vm._v(" "), _c('div', {
    staticClass: "clickAddStu",
    on: {
      "click": function($event) {
        _vm.addStudent(_vm.newStudentInf.userId, _vm.newStudentInf.realName)
      }
    }
  }, [_vm._v("添加")])])]) : _vm._e(), _vm._v(" "), (!_vm.newStudentInf && _vm.isSearch) ? _c('div', {
    staticClass: "noUsers"
  }, [_c('p', [_vm._v("未找到符合条件的学生!")])]) : _vm._e()]) : (_vm.isNewStudent) ? _c('div', {
    staticClass: "createdStudentBox"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.studentNames),
      expression: "studentNames",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "name": "student",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "请输入学生姓名，每行一个(可以直接复制粘贴Excle中的数据)"
    },
    domProps: {
      "value": (_vm.studentNames)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.studentNames = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]) : _vm._e()]), _vm._v(" "), (_vm.isNewStudent) ? _c('div', {
    staticClass: "passwordBox"
  }, [_c('span', {
    staticClass: "fl"
  }, [_vm._v("为新建账号设置初始密码:")]), _vm._v(" "), _c('div', {
    staticClass: "randomPwd fl",
    on: {
      "click": _vm.setRandomPwd
    }
  }, [_c('i', {
    staticClass: "checkKuang"
  }, [(_vm.isChecked) ? _c('u') : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("随机密码")])]), _vm._v(" "), _c('div', {
    staticClass: "initialPwd fl",
    on: {
      "click": _vm.setinitialPwd
    }
  }, [_c('i', {
    staticClass: "checkKuang"
  }, [(!_vm.isChecked) ? _c('u') : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("统一密码")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), (_vm.isNewStudent) ? _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "abolish",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v(_vm._s(_vm.params.button1 || "取消"))]), _vm._v(" "), _c('button', {
    staticClass: "ensure1 button green",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v(_vm._s(_vm.params.button2 || "确定"))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f787d4c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/addStudent.vue
// module id = 1251
// module chunks = 1